import { GroupContextType } from './groupContextType';

const GROUP_CONTEXT_STORAGE_KEY = 'group-context-id';
const GROUP_CONTEXT_COMPANY_IDS_STORAGE_KEY = 'group-context-company-ids';
const GROUP_CONTEXT_TYPE_STORAGE_KEY = 'group-context-type';

const parseGroupContextType = (value: string | null): GroupContextType | null => {
    switch (value) {
        case GroupContextType.CUSTOMER_GROUP:
        case GroupContextType.CUSTOMER_COMPANY:
        case GroupContextType.SUPPLIER_GROUP:
        case GroupContextType.SUPPLIER_COMPANY:
            return value;
        default:
            return null;
    }
};

export const setGroupContextId = (groupId: string) => {
    try {
        localStorage.setItem(GROUP_CONTEXT_STORAGE_KEY, groupId);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to store group context in localStorage:', error);
    }
};

export const setGroupContextCompanyIds = (companyIds: string[]) => {
    try {
        localStorage.setItem(GROUP_CONTEXT_COMPANY_IDS_STORAGE_KEY, JSON.stringify(companyIds));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to store group context company ids in localStorage:', error);
    }
};

export const getGroupContextCompanyIds = (): string[] => {
    try {
        const storedValue = localStorage.getItem(GROUP_CONTEXT_COMPANY_IDS_STORAGE_KEY);
        if (!storedValue) {
            return [];
        }
        const parsed = JSON.parse(storedValue);
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to retrieve group context company ids from localStorage:', error);
        return [];
    }
};

export const setGroupContextType = (type: GroupContextType) => {
    try {
        localStorage.setItem(GROUP_CONTEXT_TYPE_STORAGE_KEY, type);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to store group context type in localStorage:', error);
    }
};

export const getGroupContextType = (): GroupContextType | null => {
    try {
        const storedValue = localStorage.getItem(GROUP_CONTEXT_TYPE_STORAGE_KEY);
        return parseGroupContextType(storedValue);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to retrieve group context type from localStorage:', error);
        return null;
    }
};

export const getGroupContextId = (): string | null => {
    try {
        return localStorage.getItem(GROUP_CONTEXT_STORAGE_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to retrieve group context from localStorage:', error);
        return null;
    }
};

export const clearGroupContextId = () => {
    try {
        localStorage.removeItem(GROUP_CONTEXT_STORAGE_KEY);
        localStorage.removeItem(GROUP_CONTEXT_COMPANY_IDS_STORAGE_KEY);
        localStorage.removeItem(GROUP_CONTEXT_TYPE_STORAGE_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to clear group context from localStorage:', error);
    }
};
